var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { Divider, Space, Spin } from 'antd';
import { useSurveyByIdQuery } from 'apollo/queries/SURVEY';
import Survey from 'components/Survey/Survey';
import SurveySelect from 'components/SurveySelect';
import { StyledCollapse, CollapseHeader } from './styled';
import { enrichQuestionsWithLocalAnswers } from './helpers';
var SurveyCreationSection = function (_a) {
    var _b, _c;
    var surveyId = _a.surveyId, answersMap = _a.answersMap, onSurveyIdChange = _a.onSurveyIdChange, onAnswerChange = _a.onAnswerChange;
    var _d = useState('1'), activeKey = _d[0], setActiveKey = _d[1];
    var _e = useSurveyByIdQuery({
        variables: { id: surveyId },
        skip: !surveyId
    }), data = _e.data, loading = _e.loading;
    var surveyNodes = (_c = (_b = data === null || data === void 0 ? void 0 : data.survey) === null || _b === void 0 ? void 0 : _b.questions) === null || _c === void 0 ? void 0 : _c.nodes;
    var questions = useMemo(function () {
        return enrichQuestionsWithLocalAnswers((surveyNodes || []), answersMap);
    }, [surveyNodes, answersMap]);
    var onSurveySelect = useCallback(function (newSurveyId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            onSurveyIdChange(newSurveyId);
            return [2 /*return*/, { isErrorFree: true }];
        });
    }); }, [onSurveyIdChange]);
    var items = [
        {
            key: '1',
            label: _jsx(CollapseHeader, { children: "Questionnaire" }),
            children: (_jsxs(Space, { direction: "vertical", style: { width: '100%' }, children: [_jsx(SurveySelect, { onChange: onSurveySelect, value: surveyId }), _jsx(Divider, { style: { margin: '0' } }), surveyId ? (_jsx(Survey, { questions: questions, loading: loading, onAnswerChange: onAnswerChange })) : (_jsx(Spin, { spinning: loading }))] }))
        }
    ];
    return (_jsx(StyledCollapse, { activeKey: activeKey, onChange: setActiveKey, items: items, expandIconPosition: "end" }));
};
export default SurveyCreationSection;
